import React, { useEffect, useState } from "react";
import { Col, Collapse, Row } from "antd";
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";
import workBefore from '../../../assets/workBefore.png';
import workAfter from '../../../assets/workAfter.png';
import lunchimg from '../../../assets/lunchImg.png';
import { GoSmiley } from "react-icons/go";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import TaskSummaryMiddleware from "../../../store/Middlewares/TaskSummaryMiddleware";
import moment from "moment";
import { IMG_URL } from "../../../store/Apis";
import dummyImg from '../../../assets/dummy.png';
import AlertAction from "../../../store/Actions/AlertActions";
import styles from './ctsTab.module.css';
import { roles } from "../../../config/roles";

const { Panel } = Collapse;

function CleanersTaskSummaryTab() {
    const [isActiveOne, setIsActiveOne] = useState(true);
    const [isActiveTwo, setIsActiveTwo] = useState(false);
    const { state } = useLocation();
    const navigate = useNavigate();
    const role = localStorage.getItem('role')

    const data = state?.item;
    console.log('data', data)
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();


    useEffect(() => {
        getLanguage();
    }, [])


    const getLanguage = async () => {
        try {
            const language = localStorage.getItem('@selectedLanguage');
            i18n.changeLanguage(language)
        } catch (e) {
            console.log(e)
        }
    };




    const customizeIcon = () => {
        if (isActiveOne == true) {
            return (
                <MdKeyboardArrowUp
                    style={{
                        color: "var(--secondary-color)",
                        width: "50px",
                        height: "50px",
                    }}
                />
            );
        } else {
            return (
                <MdKeyboardArrowDown
                    style={{
                        color: "var(--secondary-color)",
                        width: "50px",
                        height: "50px",
                    }}
                />
            );
        }
    };
    const customizeIconTwo = () => {
        if (isActiveTwo == true) {
            return (
                <MdKeyboardArrowUp
                    style={{
                        color: "var(--secondary-color)",
                        width: "50px",
                        height: "50px",
                    }}
                />
            );
        } else {
            return (
                <MdKeyboardArrowDown
                    style={{
                        color: "var(--secondary-color)",
                        width: "50px",
                        height: "50px",
                    }}
                />
            );
        }
    };
    const dummyReporting = [
        {
            id: 1,
            heading: "Mood Reporting",
            text: "How’s Your Feeling After The Cleaning Service",
        },
        {
            id: 2,
            heading: "Add Note",
            text: data?.note,
        },
        {
            id: 3,
            heading: "Problem Report",
            text: data?.report_problem,
        },
    ]

    return (
        <div className={styles.mainDiv}>
            <Collapse
                className={styles.Collapse}
                expandIconPosition="end"
                defaultActiveKey={1}
                onChange={() => setIsActiveOne(!isActiveOne)}
                expandIcon={() => customizeIcon()}
                ghost
            >
                <Panel className={styles.panel} header={<p className={styles.header}>{data?.date
                    ? moment(data?.date).format('MM-DD-YYYY')
                    : ''}</p>} key="1">
                    {/* <div className={styles.panelOneHeader}>
                        <span>{t("Work Order")}</span>
                        <p>{JobDetail?.id}</p>
                    </div> */}
                    {/* <Row className={styles.panelOneRow}>
                        <Col className={styles.panelOneCol}>
                            <span>{t("Customer Name")}</span>
                            <p>{data?.customer_name}</p>
                        </Col>
                        <Col className={styles.panelOneCol}>
                            <span>{t("Cleaner Name")}</span>
                            <p>{data?.cleaner_name}</p>
                        </Col>
                    </Row> */}
                    <Row className={styles.panelOneRow}>

                        <Col className={styles.panelOneCol}>
                            <span>{t("Cleaner Name")}</span>
                            <p>{data?.cleaner_name}</p>
                        </Col>
                        {/* <Col className={styles.panelOneCol}>
                            <span>{t("Time Out")}</span>
                            <p>{moment('01 jan 1947 ' + data?.end_time).format('hh:mm A')}</p>
                        </Col> */}
                        <Col className={styles.panelOneCol}>
                            <span>{t("Work Hours")} </span>
                            <p>{data?.estimated_working_hours}</p>
                        </Col>
                    </Row>
                    <Row className={styles.panelOneRow}>

                        <Col className={styles.panelOneCol}>
                            <span>{t("Time")} </span>
                            <p>{moment('01 jan 1947 ' + data?.start_time).format('hh:mm A')} - {moment('01 jan 1947 ' + data?.end_time).format('hh:mm A')}</p>
                        </Col>
                        <Col className={styles.panelOneCol}>
                            <span>{t("Urgency")}</span>
                            <p>{data?.urgency}</p>
                        </Col>
                        {/* <Col className={styles.panelOneCol}>
                            <span>{t("Date")}</span>
                            <p>{data?.date
                                ? moment(data?.date).format('MM-DD-YYYY')
                                : ''}</p>
                        </Col> */}
                    </Row>
                    <Row className={styles.panelOneRow}>
                        <Col className={styles.panelOneCol}>
                            <span>{t("Location")}</span>
                            <p>{data?.location?.address}</p>
                        </Col>

                        <Col className={styles.panelOneCol}>
                            <span>{t("Status")} </span>
                            <p>{data?.status}</p>
                        </Col>
                    </Row>
                </Panel>
            </Collapse>
            <Collapse
                className={styles.Collapse}
                expandIconPosition="end"
                onChange={() => setIsActiveTwo(!isActiveTwo)}
                expandIcon={() => customizeIconTwo()}
                ghost

            >
                <Panel className={styles.panel} header={<p className={styles.header}>{t("Inventories")}</p>} key="1">
                    {/* <h1 className={styles.panelTwoHeading}>{t("Inventories")}</h1> */}
                    <div className={styles.panelTwolist}>
                        { data?.inventories?.length > 0 ?
                         data?.inventories.map((item, index) => {
                            return (
                                <div className={styles.panelTwoRow}>
                                    <div className={styles.panelTwoMainCol}>
                                        <h1>{item?.name}</h1>
                                    </div>
                                    <div className={styles.panelTwoMainCol}>
                                        <div className={styles.panelTwoSubMainCol}>
                                            <span>{item?.quantity_used}</span>
                                            <p>{t("Used")}</p>
                                        </div>
                                        <div className={styles.panelTwoSubMainCol}>
                                            <span>{item?.quantity}</span>
                                            <p>{t("Total")}</p>
                                        </div>
                                    </div>
                                </div>
                            );
                        }): <p style={{textAlign:'center'}}>No data found</p>}
                    </div>
                </Panel>
            </Collapse>
        </div>

    );
}

export default CleanersTaskSummaryTab